// Function to initialize video popup functionality
function initializeVideoPopup() {
  const popup = document.getElementById('video-popup');
  const closePopup = document.getElementById('close-popup');
  const closePopupPower = document.querySelector('.tv-power-handle-btn');
  const gif_tv = document.querySelector('.gif-tv');
  const prevVideo = document.getElementById('prev-video');
  const nextVideo = document.getElementById('next-video');
  const videoElement = document.getElementById('gif_tv_video');
  const is_section_enable = document.querySelector('.video-tv-section-enable');
  const videoSources = Array.from(document.querySelectorAll('.video-links li[data-url]')).map(li => li.getAttribute('data-url'));

  let currentChannel = 1;
  let timeoutId;
  let delay = 1000;

  if(is_section_enable){
     // is_section_enable.addEventListener('mouseenter', () => {
         videoElement.src = videoSources[0];
          videoElement.muted = true;
          videoElement.playsInline = true;
          videoElement.play();
         document.querySelector('.gif-tv .video-off-overlay').style.display = 'none';
         document.querySelector('.no_channel_found').style.display = 'none';
    // });
  }
  function showPopup() {
    popup.classList.remove('hidden');
    document.querySelector('.gif-tv .video-off-overlay').style.display = 'none';
    document.querySelector('.no_channel_found').style.display = 'none';
    videoElement.src = videoSources[0];
    videoElement.muted = true;
    videoElement.playsInline = true;
    videoElement.play();
  }

  function hidePopup() {
    popup.classList.add('hidden');
    videoElement.pause();
  }
 function toggleVideo() {
    const gifTv = document.querySelector('.gif-tv'); 
    const overlay = gifTv.querySelector('.video-off-overlay');

    if (videoElement.paused) {
        overlay.style.display = 'none';
        videoElement.play();
    } else {
        overlay.style.display = 'block';
        videoElement.pause();
    }
}
  function changeVideo(direction) {
    let currentVideoIndex = parseInt(document.querySelector('.gif-tv').getAttribute('data-current-channel'), 10) || 0;

    currentVideoIndex = direction === 'next' 
      ? (currentVideoIndex + 1) % videoSources.length 
      : (currentVideoIndex - 1 + videoSources.length) % videoSources.length;
    
    currentChannel = currentVideoIndex + 1;

    const channelMessage = document.querySelector('#gif_tv_viewport #gif_tv_message_channel');
    channelMessage.textContent = `CH ${currentChannel}`;
    channelMessage.classList.add('active');

    if (timeoutId) {
      clearTimeout(timeoutId);
      delay += 500;
    } else {
      delay = 1000;
    }

    timeoutId = setTimeout(() => {
      channelMessage.classList.remove('active');
      timeoutId = null;
      delay = 1000;
    }, delay);
    document.querySelector('.no_channel_found').style.display = 'none';
    videoElement.src = videoSources[currentVideoIndex];
    videoElement.playsInline = true;
    videoElement.play();
    document.querySelector('.gif-tv').setAttribute('data-current-channel', currentVideoIndex);
  }

  closePopup.addEventListener('click', hidePopup);
  closePopupPower.addEventListener('click', toggleVideo);
  prevVideo.addEventListener('click', () => changeVideo('prev'));
  nextVideo.addEventListener('click', () => changeVideo('next'));
}




// Function to initialize remote control functionality
function initializeRemoteControl() {
  const buttons = document.querySelectorAll('.gif-tv .channel_btn button');
  const videoElement = document.getElementById('gif_tv_video');
  const videoSources = Array.from(document.querySelectorAll('.video-links li[data-url]')).map(li => li.getAttribute('data-url'));
  const channelMessage = document.querySelector('#gif_tv_viewport #gif_tv_message_channel');
  const gifTvElement = document.querySelector('.gif-tv');
  let currentChannel = 0;
  let timeoutId;

  buttons.forEach(button => {
    button.addEventListener('click', () => {
      const channel = parseInt(button.getAttribute('data-channel'));

      // Append digit to the current channel
      currentChannel = currentChannel * 10 + channel;
      console.log(`Channel Input: ${currentChannel}`);

      // Show the current input
      channelMessage.textContent = `CH ${currentChannel}`;
      channelMessage.classList.add('active');

      // Clear previous timeout
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Wait for more input or finalize the channel after a timeout
      timeoutId = setTimeout(() => {
        if (currentChannel > 0 && currentChannel <= videoSources.length) {
          const currentVideoIndex = currentChannel - 1;

          // Update the video source
          videoElement.src = videoSources[currentVideoIndex];
          videoElement.playsInline = true;
          videoElement.play();
          gifTvElement.setAttribute('data-current-channel', currentVideoIndex);
          console.log(`Playing channel: ${currentChannel}`);
        } else {
          
          document.querySelector('.no_channel_found').style.display = 'block';
          videoElement.pause();
          console.log(`Invalid channel: ${currentChannel}`);
        }

        // Reset the channel input
        currentChannel = 0;
        channelMessage.classList.remove('active');
      }, 1000); // 1 second to wait for additional input
    });
  });
}

// Main initialization function
function main() {
  document.addEventListener('DOMContentLoaded', () => {
    initializeVideoPopup();
    const videoLinks = document.querySelectorAll('.video-links li[data-url]');
    const gifTVURLs = Array.from(videoLinks).map(li => li.getAttribute('data-url'));
    initializeRemoteControl();
  });
}

main();

// Video mute/unmute functionality
const video = document.getElementById('gif_tv_video');
const muteButton = document.querySelector('.tv-sound-handle-btn');
const tvSectionFixed = document.querySelector('.tv-section-fixed');

muteButton.addEventListener('click', () => {
  video.muted = !video.muted;
});

tvSectionFixed.addEventListener('click', () => {
  document.getElementById('video-popup').classList.remove('hidden');
  const videoSources = Array.from(document.querySelectorAll('.video-links li[data-url]')).map(li => li.getAttribute('data-url'));
  video.src = videoSources[0];
  video.muted = true;
  video.playsInline = true;
  video.play();
  video.muted = false;
  document.querySelector('.gif-tv .video-off-overlay').style.display = 'none';
   document.querySelector('.no_channel_found').style.display = 'none';
});

// Video volume control functionality
const volumeDown = document.getElementById('volumeDown');
const volumeUp = document.getElementById('volumeUp');
const volumeMessage = document.querySelector('#gif_tv_viewport #gif_tv_message_volume');

volumeDown.addEventListener('click', () => {
  if (video.volume > 0) {
    video.volume = Math.max(0, video.volume - 0.1);
  }
  updateVolumeMessage();
});

volumeUp.addEventListener('click', () => {
  if (video.volume < 1) {
    video.volume = Math.min(1, video.volume + 0.1);
  }
  updateVolumeMessage();
});

let volumeTimeoutId;
let volumeDelay = 1000;

function updateVolumeMessage() {
  volumeMessage.textContent = `VOL ${Math.round(video.volume * 10)}`;
  volumeMessage.classList.add('active');

  if (volumeTimeoutId) {
    clearTimeout(volumeTimeoutId);
    volumeDelay += 500;
  } else {
    volumeDelay = 1000;
  }

  volumeTimeoutId = setTimeout(() => {
    volumeMessage.classList.remove('active');
    volumeTimeoutId = null;
    volumeDelay = 1000;
  }, volumeDelay);
}
